var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31678 19.4389C5.92511 18.0057 7.34541 17.0005 9.00049 17.0005H15.0005C16.6556 17.0005 18.0759 18.0057 18.6842 19.4389M16.0005 9.50049C16.0005 11.7096 14.2096 13.5005 12.0005 13.5005C9.79135 13.5005 8.00049 11.7096 8.00049 9.50049C8.00049 7.29135 9.79135 5.50049 12.0005 5.50049C14.2096 5.50049 16.0005 7.29135 16.0005 9.50049ZM22.0005 12.0005C22.0005 17.5233 17.5233 22.0005 12.0005 22.0005C6.47764 22.0005 2.00049 17.5233 2.00049 12.0005C2.00049 6.47764 6.47764 2.00049 12.0005 2.00049C17.5233 2.00049 22.0005 6.47764 22.0005 12.0005Z",
    stroke: "#8E98A8",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.fa97efa2ce7f1ad210fb0c4e439d327b.svg";
export { ForwardRef as ReactComponent };